import { numberWithCommaWithoutDecimals } from '@wiggot/utils/src/formatters'
import {
  useFilterStore,
  useZoneInformationStore,
} from '../../../../../state-library/src'
import { EPropertyType } from '../../../../../types-library/src'
import { useMemo } from 'react'
import { MdOutlineLocalAtm, MdOutlineViewInAr } from 'react-icons/md'
import AveragesSkeleton from './AveragesSkeleton'

const Averages = () => {
  const { zone: data, isLoading } = useZoneInformationStore()

  const { propertyType } = useFilterStore()

  const zone = useMemo<{
    avgPrice?: string
    avgM2Price?: string
    avgSurface?: string
  }>(() => {
    return {
      avgPrice: numberWithCommaWithoutDecimals(data?.avgPrice ?? 0),
      avgM2Price: numberWithCommaWithoutDecimals(data?.avgM2Price ?? 0),
      avgSurface: numberWithCommaWithoutDecimals(data?.avgSurface ?? 0),
    }
  }, [data])

  const isEmpty = useMemo(() => {
    return !data.avgPrice
  }, [data])

  if (isLoading) {
    return <AveragesSkeleton />
  }

  return isEmpty && !isLoading ? (
    <></>
  ) : (
    <div className="border border-[#EBEDF0] rounded-[4px] overflow-hidden">
      <div className="p-4">
        <p className="text-primary text-sm font-semibold">
          {propertyType === EPropertyType.RENT ? 'Renta' : 'Precio'} promedio de
          los anuncios:
        </p>
        <div className="flex items-center gap-1 text-primary text-lg font-semibold">
          <p>$</p>
          <p>{zone.avgPrice}</p>
          <p className="text-[#BABDD5] text-sm font-semibold">MXN</p>
        </div>
      </div>

      <div className="py-3 px-4 bg-[#F4F7FA] flex flex-col gap-4">
        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center p-1 bg-[rgba(91,114,130,0.10)] rounded-lg w-7 h-7">
            <MdOutlineLocalAtm className="w-5 h-5  fill-[#726E7D]" />
          </div>
          <div>
            <p className="text-sm font-semibold text-secondary">
              {propertyType === EPropertyType.RENT ? 'La renta' : 'El precio'}{' '}
              promedio por m²:
            </p>
            <p className="text-sm font-semibold mt-0.5">
              $ {zone.avgM2Price} mxn
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2.5">
          <div className="flex items-center justify-center p-1 bg-[rgba(91,114,130,0.10)] rounded-lg w-7 h-7">
            <MdOutlineViewInAr className=" w-5 h-5 fill-[#726E7D]" />
          </div>
          <div>
            <p className="text-sm font-semibold text-secondary">
              El tamaño promedio:
            </p>
            <p className="text-sm font-semibold mt-0.5">{zone.avgSurface} m²</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Averages
